module.exports = __webpack_public_path__ + "img/denti_calc_icon_20200619.b7740b36.png";